import React, { useRef, useEffect } from 'react';
import './background-animation.css';

//The last 2 digits at the end of the hex code is for alpha
//Use this blue color for admin, but use the govenda turquoise color for web app when we get there
const fillStyle: string = '#F75A23';

type Circle = {
  x: number,
  y: number,
  radius: number, 
  vx: number, 
  vy: number,
  alpha: string
}

const BgAnimationCanvas = props => {
  const canvasRef = useRef(null);
  const canvasTest = useRef(null);

  useEffect(() => {
    let lines: Line[] = [];
    let circles: Circle[] = [];
    let animationFrameId: number;

    const isCanvasSupported = () => {
      canvasTest.current = document.createElement('canvas');
      return !!(canvasTest.current.getContext && canvasTest.current.getContext('2d'));
    };
    
    // get canvas, context, and set width + height
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    // draw the scene
    const draw = (ctx: { fillStyle: string; strokeStyle: string; arc: (arg0: number, arg1: number, arg2: number, arg3: number, arg4: number) => void; fill: () => void; beginPath: () => void; closePath: () => void; stroke: () => void;}, objs: Circle[]) => {
      const c = canvasRef.current;
      const ch = c.height = window.innerHeight;	

      for(let i =0; i<objs.length;i++) {
        const c = objs[i];

        ctx.fillStyle = fillStyle + c.alpha;
        ctx.strokeStyle = fillStyle;

        ctx.beginPath();
        ctx.arc(c.x,c.y,c.radius,0,2*Math.PI);
        ctx.fill();
        ctx.closePath();

      }
  };

    const loop = () => {
      animationFrameId = requestAnimationFrame(loop);
      
        for(let i=0;i<circles.length;i++) {
          const c = circles[i]

          if(c.x > canvas.width- c.radius || c.x<c.radius) { c.vx=-c.vx; }
          if(c.y > canvas.height -c.radius || c.y<c.radius)  { c.vy=-c.vy; }
            c.x+=c.vx;
            c.y+=c.vy;

        }
      
        draw(ctx, circles);
    };
    
    const randomInt = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1) + min);
    
    const cw = canvas.width = window.innerWidth;
    const ch = canvas.height = window.innerHeight;	

    if (isCanvasSupported()) {
      for(let i=0; i<16;i++) {

        var radius = randomInt(10,110)
        var v1 = randomInt(1,3)
        var v2 = randomInt(1,3)

        var x = randomInt(0,cw-radius)
        while (x > canvas.width- radius || x<radius) {
          x = randomInt(0,cw-radius)
        }

        var y = randomInt(0,cw-radius)
        while (y > canvas.height -radius || y<radius) {
          y = randomInt(0,cw-radius)
        }

        var alpha = `${randomInt(1,3)}${randomInt(1,3)}`

        const circle: Circle = {
          x: x,
          y: y,
          radius: radius,
          vx: v1,
          vy: v2,
          alpha: alpha
        }
      
        circles.push(circle);
      }
    
      loop();
    }

    return () => {
      window.cancelAnimationFrame(animationFrameId);
    }
  }, [])

  return <canvas ref={canvasRef} {...props} />;
}

export default BgAnimationCanvas;